import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { container } from 'tsyringe';
import * as R from 'ramda';

import { ApiService } from '../../services/api-service';
import { PTApiService } from '../../services/ptapi-service';
import { MediaService } from '../../services/media-service';
import { WebRTCsdkService } from '../../services/webrtcsdk-service';
import { PeopleService } from '../../services/people-service';


import FullPlayerVideoComponent from '../producerPlayer/FullPlayerVideo';
import { Media, MediaOrigin, MediaType } from '../../models/mediaClass';
import { SELECT_MEDIA, UNSELECT_MEDIA } from '../../redux/medias/mediaReducer';
import { useSharedState } from '../../utils/helpers';

import { ActionType } from '../../models/actionClass';
import { PTSocketService } from '../../services/ptsocket.service';
import { MEETING_SET_RECEIVING_CONTENT, MEETING_SET_RECEIVING_VIDEOID, MEETING_SET_SHARING_CONTENT } from '../../redux/meeting/meetingReducer';
import { MeetingStore, SharingState } from '../../models/meetingClass';

export const videoStatusEnum = {
  OPEN: 'OPEN',
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  CLOSED: 'CLOSED',
}


export const Foregrounds = () => {

  const { fgVideo, fgImage } = useSelector((state: any) => ({
    fgVideo: state.media.fgVideo,
    fgImage: state.media.fgImage,
  }));
  const dispatch = useDispatch();

  const [apiService] = useState(container.resolve(ApiService));
  const [mediaService] = useState(container.resolve(MediaService));

  const [ptApiService] = useState(container.resolve(PTApiService));
  const [ptSocketService] = useState(container.resolve(PTSocketService));
  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [peopleService] = useState(container.resolve(PeopleService));

  const [sharedVideoState, setSharedVideoState] = useSharedState(ptSocketService.sharedVideo$);
  const [videoSharingInitial] = useSharedState(ptApiService.videoSharingInitial$);
  const [videoSharingAction] = useSharedState(webRTCsdkService.videoAction$);

  const [playStatus, setPlayStatus] = useState(videoStatusEnum.CLOSED);

  const meetingStore: MeetingStore = useSelector((state: any) => state.meetingStore);


  const handleCloseImage = () => {
    // dispatch empty fgImage
    dispatch({type: UNSELECT_MEDIA, payload: MediaType.FG_IMAGE});
    mediaService.unselect(MediaType.FG_IMAGE, fgImage.id);

    console.log('SHARE showlive closeImage SET_SHARING_CONTENT', {
      sharingContent: false,
      sharingLocalContent: SharingState.NONE
    })

    dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: {
      sharingContent: false,
      sharingLocalContent: SharingState.NONE
    }});

    apiService.updateReason = {group: MediaType.FG_IMAGE, action: ActionType.UNSELECT, id: fgImage.id};
    apiService.saveChannel('unselect image');
  }

  const closeFullPlayer = () => {
    // dispatch empty fgVideo
    dispatch({type: UNSELECT_MEDIA, payload: MediaType.FG_VIDEO});
    mediaService.unselect(MediaType.FG_VIDEO, fgVideo?.id);


    if (fgVideo && fgVideo.id) {
      // ptApiService.shareVideoAction(fgVideo.id, 'stop', 0);
      setSharedVideoState({id: fgVideo.id, state: videoStatusEnum.CLOSED, seek: 0});
    }

    webRTCsdkService.releasePresentationToken();

    apiService.updateReason = {group: MediaType.FG_VIDEO, action: ActionType.UNSELECT, id: fgVideo?.id};
    apiService.saveChannel('unselect video');
  }

  useEffect(() => {
    // console.log('shared video status: ', sharedVideoState);
    try {
      const status = videoStatusEnum[sharedVideoState.state] || videoStatusEnum.CLOSED;
      if (status !== playStatus) {
        setPlayStatus(status);
      }
      const myself = peopleService.getMySelf();

      if (status !== videoStatusEnum.CLOSED) {

        // console.log('SHARE showlive SET_RECEIVING_VIDEOID', {
        //   videoId: sharedVideoState.contentId.toString(),
        // })

        dispatch({type: MEETING_SET_RECEIVING_VIDEOID, payload: {
          videoId: sharedVideoState.contentId.toString(),
        }})


        // console.log('SHARE showlive  SET_RECEIVING_CONTENT ', {
        //   receivingContent: true,
        //   presenterName: myself?.name || '',
        //   presenterGuid: myself?.seamGuid || '',
        // })


        dispatch({type: MEETING_SET_RECEIVING_CONTENT, payload: {
          receivingContent: true,
          presenterName: myself?.name || '',
          presenterGuid: myself?.seamGuid || '',
        }});

        // console.log('SHARE showlive SET_SHARING_CONTENT', {
        //   sharingContent: true,
        //   sharingLocalContent: SharingState.VIDEO
        // })

        dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: {
          sharingContent: true,
          sharingLocalContent: SharingState.VIDEO
        }});


        // update or create selectedVideo
        if (fgVideo) {

          if (fgVideo.id !== sharedVideoState.id.toString() ||
             fgVideo.hls == '') {

            fgVideo.hls = sharedVideoState.hlsUrl;
            dispatch({type: SELECT_MEDIA, payload: R.clone(fgVideo)});
            apiService.updateReason = {group: MediaType.FG_VIDEO, action: ActionType.SELECT, id: fgVideo.id};
            apiService.saveChannel('sharedVideo');
          }


        } else if (sharedVideoState.id.toString() !== fgVideo.id) {
          // create and add a fgVideo
          const video = new Media(sharedVideoState.id.toString(), '', 'remote', sharedVideoState.hlsUrl, MediaType.FG_VIDEO, MediaOrigin.MEETING_ASSET);
          dispatch({type: SELECT_MEDIA, payload: R.clone(video)});
          apiService.updateReason = {group: MediaType.FG_VIDEO, action: ActionType.SELECT, id: video.id};
          apiService.saveChannel('sharedVideo');
        }
      } else {

        console.log('VIDEO status is STOPPED', sharedVideoState.endpointGUID , myself.endpointGUID);

        // if (sharedVideoState.endpointGUID === meetingStore.presenterGuid) {

          // stop video sharing
          // console.log('SHARE sharedVideoState stopped SET_RECEIVING_VIDEOID', {
          //   videoId: '',
          // })
          dispatch({type: MEETING_SET_RECEIVING_VIDEOID, payload: {
            videoId: ''
          }})

          // console.log('SHARE sharedVideoState stopped SET_SHARING_CONTENT', {
          //   sharingContent: false,
          //   sharingLocalContent: SharingState.NONE
          // })
          dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: {
            sharingContent: false,
            sharingLocalContent: SharingState.NONE
          }});
        // } else {
        //   // video has been stopped by other moderator :(
        //   // restart the video

        // }
      }

    } catch(e) {}
  }, [sharedVideoState])


  useEffect(() => {
    // console.log('shared video initial', videoSharingInitial);
    if (videoSharingInitial) {
      setSharedVideoState(videoSharingInitial);
    }
  }, [videoSharingInitial]);

  useEffect(() => {
    if (videoSharingAction === 'stop') {
      console.log('VIDEO sharing action STOP')
      closeFullPlayer();
      webRTCsdkService.setVideoSharingAction('');
    }
  }, [videoSharingAction])

  return (
    <>
      { fgImage?.id?.length > 0 && (!sharedVideoState || playStatus === 'CLOSED') &&
        <>
        <div className='LivePreview-foreground' style={{ backgroundImage: `url(${fgImage.source})` }}></div>
        {/* <div className="LivePreview-foreground-close" onClick={handleCloseImage}></div> */}
        </>
      }

{/* url={sharedVideoState.hlsUrl} */}
{/* isSelf={sharedVideoState.isSelf} */}
      { sharedVideoState && playStatus !== 'CLOSED' &&
        <div className='LivePreview-foreground'>
          <FullPlayerVideoComponent
            id= {sharedVideoState.contentId}
            url={fgVideo?.mp4}
            name={'remote'}
            playStatus={playStatus}
            offset={sharedVideoState.offset}
            isSelf={true}
            onClosePlayer={closeFullPlayer}
          >
          </FullPlayerVideoComponent>
        </div>
      }
    </>
  )
}

